const SkeletonWorkshopCard = () => {
  return (
    <div className="flex items-center gap-4 bg-white p-4 rounded shadow-sm">
      <div className="h-16 w-16 rounded bg-shimmer bg-[length:400%_100%] animate-shimmer" />
      <div className="flex flex-col gap-2 flex-1">
        <div className="h-4 bg-shimmer rounded w-3/4 bg-[length:400%_100%] animate-shimmer" />
        <div className="h-3 bg-shimmer rounded w-1/2 bg-[length:400%_100%] animate-shimmer" />
        <div className="h-3 bg-shimmer rounded w-1/3 bg-[length:400%_100%] animate-shimmer" />
      </div>
    </div>
  );
};

export default SkeletonWorkshopCard;
